import { useContext } from 'react'
import { CampaignSidebarContext } from './CampaignSidebarContext'

export const useCampaignSidebar = () => {
  const context = useContext(CampaignSidebarContext)

  if (!context) {
    throw new Error('useCampaignSidebar must be used within CampaignSidebarProvider')
  }

  return context
}
